// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2NmaX","col":"styles_col__2jBvI"};